// modules matching this selector reveal almost as soon as they enter the
// viewport at all — the default threshold (15% of the module's OWN height
// visible, -10% from the bottom) reads fine for typical full-height
// sections, but breaks down at either extreme: too easy to miss on a short
// module like ".teaser-textbox", and literally impossible to satisfy on a
// very tall one like ".teaser--tiles" (the news overview's stacked list of
// article teasers, easily 5-10x the viewport height) — 15% of a
// several-thousand-pixel-tall element is more than a whole viewport can
// ever show at once, so it would stay invisible (opacity: 0) forever
// ".text-module" joins this list for the same "impossible to satisfy"
// reason as ".teaser--tiles": long-form legal/text pages (e.g. the footer's
// Data Privacy Statement) can run several thousand px tall, so 15% of the
// module's own height is never simultaneously visible and it stayed at
// opacity:0 forever — confirmed via a real page's computed styles (opacity
// ~0.0004, is-visible never added).
const earlyRevealSelector = '.teaser-textbox, .teaser--tiles, .text-module';

function createObserver(threshold, rootMargin) {
    return new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
        });
    }, { threshold, rootMargin });
}

export default function InitScrollReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    // the full-bleed hero is typically the page's LCP element — hiding it
    // at opacity:0 until an IntersectionObserver round-trip + a .6s
    // transition finish delays LCP for content that's already visible on
    // load, for no visual benefit (it's never scrolled into view, it's
    // already there)
    const modules = document.querySelectorAll('.module:not(.module--full-bleed-hero)');
    if (!modules.length) return;

    const defaultObserver = createObserver(0.15, '0px 0px -10% 0px');
    const earlyObserver = createObserver(0.01, '0px');

    modules.forEach((module) => {
        module.classList.add('animate-on-scroll');
        if (module.matches(earlyRevealSelector)) {
            earlyObserver.observe(module);
        } else {
            defaultObserver.observe(module);
        }
    });
}
